export default {
  en: {
    pageTitle: 'Discussions',
    threadPageTitle: '{orgName} - Discussions',
    config: {
      fetchError: 'Failed to get discussions preferences',
      updateError: 'Failed to update discussions preferences',
      title: 'Discussions',
      seenTitle: 'Seen',
      seenDesc:
        'By enabling the seen option, you will be able to see that when your last comment was seen in a discussion.',
    },
    placeholder: {
      comment: 'Comment here...',
      reply: 'Reply here...',
      openDiscussions: 'You have {0} open discussions - select a discussion to reply to the users',
      noOpenDiscussions: 'No open discussions',
      noOpenDiscussionsSubtitle: "When you have a discussion open, it'll appear here.",
      noArchivedDiscussions: 'No archived discussions',
      noArchivedDiscussionsSubtitle: 'Discussions you archive will appear here.',
      openDiscussionsWithOrg:
        "You have {0} open discussions - select a discussion to reply to the users at {1} and when you're ready mark it as archived.",
      noOpenDiscussionsWithOrg:
        'You have no open discussions but if you need more information from {0}, you can start one below.',
    },
    label: {
      comment: 'Comment',
      reply: 'Reply',
    },
    validation: {
      emptyComment: 'Write a comment before sending',
      emptyReply: 'Write a reply before sending',
      attachmentsUploading: 'Wait for your attachments to finish uploading',
    },
    button: {
      send: 'Send',
      startNewDiscussion: 'Start new discussion',
      newDiscussion: 'New discussion',
    },
    comments: {
      previousMessages: 'Show previous messages...',
      seen: 'Seen',
      seenAt: 'Seen at {0}',
    },
    title: {
      newDiscussion: 'New discussion',
      genericDiscussion: 'Discussion started by {0}',
      discussionsInbox: 'Inbox',
    },
    failed: 'Failed sending comment',
    failedStartingDiscussion: 'Failed to start a discussion',
    failedGettingDiscussions:
      'Failed to get discussions. Try again or contact Risk Ledger support.',
    filters: {
      active: 'Active discussions',
      archived: 'Archived discussions',
      list: {
        open: 'Open',
        archived: 'Archived',
        all: 'All discussions',
        my: 'My discussions',
      },
    },
    archiver: {
      archive: 'Archive',
      unarchive: 'Unarchive',
    },
    timestampFormat: 'YYYY/MM/DD h:mm A',
    info: {
      noDiscussions: 'No discussions found',
      noDiscussionsNote:
        'Start a new discussion using the button in the sidebar or from the assessment tab',
    },
    associated: {
      emptyTitle: 'No discussion yet',
    },
    attachments: {
      filesAttached: 'Attach files | {n} file attached | {n} files attached',
    },
    list: {
      error: 'Error fetching discussions',
    },
    listItem: {
      descriptionOtherReplied: 'Reply from {0}',
      descriptionYouReplied: 'Replied to {0}',
      descriptionOtherRepliedWithEntity: 'Reply from {0} on',
      descriptionYouRepliedWithEntity: 'Replied to {0} on',
      scopingQuestionEntityName: 'Scoping question {0}',
      control: 'Control {0}.{1}',
      associatedEntityName: '{0}',
      associatedAnswerName: '{0} - in relation to {1}',
      associatedarchivedAnswer: 'an archived answer',
    },
    controlContext: {
      linkToControl: 'Go to control',
      lastModifiedDateFormat: 'yyyy/dd/MM',
      inRelationTo: 'In relation to {product}',
      archivedBadge: 'Archived answer',
      unavailable: 'The associated control is no longer available.',
    },
    scopingContext: {
      url: 'Learn more about this domain',
      outOfScope: 'Domain is out of scope.',
      inScope: 'Domain is in-scope.',
      answeredClient: 'Answered',
      answeredSupplier: 'You answered',
      yes: 'Yes',
      no: 'No',
    },
    emergingThreatContext: {
      url: 'Learn more about this Emerging Threat',
      timestampFormat: 'YYYY/DD/MM',
      status: 'Status',
      lastUpdated: 'Last updated',
      published: 'published {0}',
    },
    entityName: 'Discussion',
    filterAttributes: {
      archived: 'Archived',
      unarchived: 'Unarchived',
      hasEvidence: 'Evidence',
      hasEvidenceTrue: 'Has evidence',
      hasEvidenceFalse: 'No evidence',
      associatedType: 'Associated type',
      control: 'Control',
      emergingThreat: 'Emerging Threat',
      connection: 'Connection',
      scoping: 'Scoping question',
    },
    associatedItemLinkButton: {
      controlText: 'View control',
      emergingThreatText: 'View Emerging Threat',
      scopingText: 'View domain',
    },
  },
};
